// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageWrapper_wrapper__3o6u1"};